import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Clock } from "lucide-react";
import { SunLogo } from "./SunLogo";
import { BUSINESS, SERVICES, CITIES } from "../data/site";

export const Footer = () => (
  <footer data-testid="site-footer" className="bg-[#0A0B0E] border-t border-white/10 pb-28">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
        <div>
          <div className="flex items-center gap-3 mb-4">
            <SunLogo size={34} />
            <span className="font-heading leading-tight">
              <span className="block font-bold text-white text-lg">1st Nations Security</span>
              <span className="block text-[10px] font-semibold uppercase tracking-widest text-[#FF9100]">Manitoba Security Services</span>
            </span>
          </div>
          <p className="text-sm text-gray-400 leading-relaxed mb-5">
            Indigenous-owned and operated security guard company serving Winnipeg, Brandon, and every region of Manitoba with professional guarding, patrol, and response services.
          </p>
          <ul className="space-y-2.5 text-sm">
            <li>
              <a href={BUSINESS.phoneHref} data-testid="footer-phone-link" className="flex items-center gap-2 text-gray-300 hover:text-[#FF9100] transition-colors">
                <Phone className="w-4 h-4 text-[#FF9100]" /> {BUSINESS.phone}
              </a>
            </li>
            <li>
              <a href={BUSINESS.emailHref} data-testid="footer-email-link" className="flex items-center gap-2 text-gray-300 hover:text-[#FF9100] transition-colors">
                <Mail className="w-4 h-4 text-[#FF9100]" /> {BUSINESS.email}
              </a>
            </li>
            <li className="flex items-center gap-2 text-gray-400">
              <MapPin className="w-4 h-4 text-[#FF9100]" /> Serving all of Manitoba, Canada
            </li>
            <li className="flex items-center gap-2 text-gray-400">
              <Clock className="w-4 h-4 text-[#FF9100]" /> 24/7 dispatch, 365 days a year
            </li>
          </ul>
        </div>

        <nav aria-label="Security services">
          <h3 className="text-xs font-semibold uppercase tracking-widest text-[#FF9100] mb-4">Security Services</h3>
          <ul className="space-y-2 text-sm">
            <li><Link to="/security-services" data-testid="footer-services-all" className="text-gray-300 font-semibold hover:text-[#FF9100] transition-colors">All Services</Link></li>
            {SERVICES.map((s) => (
              <li key={s.slug}>
                <Link to={`/security-services/${s.slug}`} data-testid={`footer-service-${s.slug}`} className="text-gray-400 hover:text-[#FF9100] transition-colors">
                  {s.title}
                </Link>
              </li>
            ))}
          </ul>
        </nav>

        <nav aria-label="Manitoba service areas">
          <h3 className="text-xs font-semibold uppercase tracking-widest text-[#FF9100] mb-4">Manitoba Service Areas</h3>
          <ul className="grid grid-cols-2 gap-x-3 gap-y-2 text-sm">
            {CITIES.map((c) => (
              <li key={c.slug}>
                <Link to={`/security-guards/${c.slug}`} data-testid={`footer-city-${c.slug}`} className="text-gray-400 hover:text-[#FF9100] transition-colors">
                  {c.name}
                </Link>
              </li>
            ))}
          </ul>
        </nav>

        <nav aria-label="Company">
          <h3 className="text-xs font-semibold uppercase tracking-widest text-[#FF9100] mb-4">Company</h3>
          <ul className="space-y-2 text-sm">
            <li><Link to="/about" data-testid="footer-about" className="text-gray-400 hover:text-[#FF9100] transition-colors">About 1st Nations Security</Link></li>
            <li><Link to="/indigenous-security" data-testid="footer-indigenous" className="text-gray-400 hover:text-[#FF9100] transition-colors">Indigenous-Owned Security</Link></li>
            <li><Link to="/service-areas" data-testid="footer-areas" className="text-gray-400 hover:text-[#FF9100] transition-colors">All Service Areas</Link></li>
            <li><Link to="/contact" data-testid="footer-contact" className="text-gray-400 hover:text-[#FF9100] transition-colors">Contact Us</Link></li>
          </ul>
          <div className="mt-6 p-4 rounded-xl border border-[#FF9100]/25 bg-[#FF9100]/5">
            <p className="text-xs text-gray-300 leading-relaxed">
              100% Indigenous-Owned & Community Dedicated Security Provider
            </p>
          </div>
        </nav>
      </div>

      <div className="mt-12 pt-6 border-t border-white/5 flex flex-col sm:flex-row items-center justify-between gap-3">
        <p className="text-xs text-gray-500">© {new Date().getFullYear()} 1st Nations Security. Security guard services across Manitoba, Canada.</p>
        <p className="text-xs text-gray-600">Winnipeg · Brandon · Steinbach · Thompson · All Manitoba Communities</p>
      </div>
    </div>
  </footer>
);
